import {getTemplateFromAppStyles} from "./getTemplateFromAppStyles";

export function isTemplateEnabled(appStyles, templateKey) {
  const selectedTemplate = getTemplateFromAppStyles(appStyles);
  return selectedTemplate === templateKey;
}
